import { Icon, Tooltip } from "@shopify/polaris"
import { ClipboardIcon } from "@shopify/polaris-icons"
import classNames from "classnames"
import copy from "copy-to-clipboard"
import { useTranslation } from "react-i18next"

import toast from "@/utils/toast"

import styles from "./CopyField.module.scss"

interface CopyFiledProps {
  copyValue?: string
  children?: React.ReactNode | string
  toolTipText: string
  config?: {
    reverse?: boolean
    hover?: boolean
  }
}

export default function CopyField({ copyValue, children, toolTipText, config }: CopyFiledProps) {
  const { t } = useTranslation(["common"])

  const handleCopyClick = () => {
    if (copyValue) {
      copy(copyValue)
      toast(t("common:CopiedSuccessfully"))
    }
  }

  return (
    <div className={classNames(
      "flex items-center cursor-pointer max-w-full",
      config?.reverse ? "flex-row-reverse" : "",
      config?.hover ? styles.hoverCopyFieldWrapper : "",
    )}
    >
      {
        copyValue ? <div className={classNames("relative", styles.copyFieldIcon)} style={{ zIndex: 2 }}>
          <Tooltip content={toolTipText} dismissOnMouseOut>
            <div onClick={handleCopyClick}>
              <Icon source={ClipboardIcon} tone={"base"} />
            </div>
          </Tooltip>
        </div> : null
      }
      {children || "-"}
    </div>
  )
}
